<template>
  <v-card class="mt-3 pa-4">
    <h3 class="calculation-title">Tags</h3>
    <v-row>
      <v-col cols="4">
        <v-text-field
            label="Add tag"
            hide-details="auto"
            v-model="newTagName"
            :disabled="selectedTag === {} || selectedDeleteTagIds.length > 0 "
        />
      </v-col>
      <v-col cols="4">
        <v-select
            item-text="label"
            item-value="id"
            :items="tags"
            label="Current tags"
            v-model="selectedTag"
            @change="tagId"
            return-object
            :disabled="selectedDeleteTagIds.length > 0 || newTagName !== ''"
        >
        </v-select>
      </v-col>
      <v-col cols="4">
        <v-select
            item-text="label"
            item-value="id"
            :items="tags"
            label="Remove tags"
            v-model="selectedDeleteTagIds"
            multiple
            :disabled="newTagName !== ''"
        >
        </v-select>
      </v-col>
    </v-row>
    <v-simple-table dense>
      <template v-slot:default v-if="selectedDeleteTagIds.length === 0">
        <thead>
        <tr>
          <th class="text-left title-padding">
          </th>
          <th class="text-left title-padding" v-for="constant in p" :key="`constant_${constant}`">
            {{ capitalizeWords(constant) }}
          </th>
        </tr>
        </thead>
        <tbody>
        <td>
        </td>
        <user-permissions-tag-table-row
            v-for="(item, key) in selectedTag ? Object.entries(selectedTag.value) : Object.keys(permissions)"
            :key="`permission_${key}`"
            :view="selectedTag ? item[0] : item" :selectedTag="selectedTag ? selectedTag.value : null"
            :edit="selectedTag ? selectedTag.value : newTag"/>
        </tbody>
      </template>
    </v-simple-table>
<!--    <v-btn @click="handleEditTagClick()" v-if="selectedTag" class="mt-5" color="success">Save</v-btn>-->
    <v-btn @click="handleDeleteTagsClick()" v-if="selectedDeleteTagIds.length > 0" class="mt-5" color="success">Delete</v-btn>
    <v-btn @click="handleAddTagClick()" v-if="selectedDeleteTagIds.length === 0" class="mt-5" color="success" :disabled="newTagName === '' || !permissionAdded">Add</v-btn>
    <v-btn @click="handleReset()" class="mt-5 reset-btn-margin" color="primary"> Reset</v-btn>
  </v-card>
</template>

<script>
import {mapActions, mapMutations, mapState} from "vuex";
import {PermissionsConstants} from "@/permissions";
import UserPermissionsTagTableRow from "@/components/user-permissions/UserPermissionsTagTableRow";

export default {
  name: "UserPermissionsTagTable",
  components: {
    'user-permissions-tag-table-row': UserPermissionsTagTableRow
  },
  data() {
    return {
      p: PermissionsConstants,
      newTagName: '',
      selectedTag: null,
      selectedTagId: null,
      selectedDeleteTagIds: [],
      permissionAdded: false
    }
  },
  computed: {
    ...mapState('userPermissions', ['tags', 'newTag']),
    ...mapState('user', ['permissions'])
  },
  async mounted() {
    await this.fetchAllPermissions()
  },
  watch:{
    newTagName(){
      this.selectedTag = null
    },
    newTag(){
      this.permissionAdded = false
      Object.values(this.newTag)?.forEach(view => {
        if(view.length > 0){
          this.permissionAdded = true
        }
      })
    }
  },
  methods: {
    ...mapActions('userPermissions', ['editTag', 'addNewTag', 'deleteTags']),
    ...mapActions('user', ['fetchAllPermissions']),
    ...mapMutations('userPermissions', ['setNewTagName', 'setResetNewTag']),
    tagId() {
      this.selectedTagId = this.tags.indexOf(this.selectedTag)
    },
    capitalizeWords(arr) {
        arr = arr.replaceAll('_', ' ')
        return arr.charAt(0).toUpperCase() + arr.slice(1).toLowerCase();
    },
    async handleReset() {
      this.newTagName = ''
      this.selectedTag = null
      this.permissionAdded = false
      this.selectedDeleteTagIds = []
      await this.setResetNewTag()
    },
    async handleAddTagClick() {
      await this.setNewTagName(this.newTagName)
      await this.addNewTag()
      this.newTagName = ''
      this.selectedTag = null
    },
    async handleEditTagClick() {
      await this.editTag({tagId: this.tags[this.selectedTagId]?.id, permissions: this.tags[this.selectedTagId]?.value})
      await this.handleReset()
    },
    async handleDeleteTagsClick(){
      let stringSelectedDeleteTagIds = this.selectedDeleteTagIds.map(Number).join(',')
      await this.deleteTags(stringSelectedDeleteTagIds)
      this.newTagName = ''
      this.selectedTag = null
      this.selectedDeleteTagIds = []
    }
  }
}
</script>

<style scoped>
.reset-btn-margin {
  margin-left: 15px
}
</style>